import { useState, useCallback, useEffect } from 'react';

// Tema actual leído del <html data-theme>. Default oscuro (lo setea public/index.html).
export function getTheme() {
  const t = typeof document !== 'undefined'
    ? document.documentElement.getAttribute('data-theme')
    : 'dark';
  return t === 'light' ? 'light' : 'dark';
}

let _animTimer = null;
export function applyTheme(next) {
  const html = document.documentElement;
  // activa la transición suave solo durante el cambio (el "viaje" de color)
  html.classList.add('ic-theme-anim');
  html.setAttribute('data-theme', next);
  try { localStorage.setItem('ic-theme', next); } catch (e) {}
  if (_animTimer) clearTimeout(_animTimer);
  _animTimer = setTimeout(() => html.classList.remove('ic-theme-anim'), 650);
}

// Hook para el toggle. Devuelve { theme, toggle }.
export function useTheme() {
  const [theme, setTheme] = useState(getTheme);
  const toggle = useCallback(() => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      return next;
    });
  }, []);
  useEffect(() => { setTheme(getTheme()); }, []);
  return { theme, toggle };
}
